<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin                                                                         -->
        <v-card class="box" v-if="ay_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Academic Planner </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn class="mb-2 button" color="warning" @click="mark_holiday_dialog = true" small>Mark
                    Weekly-Off</v-btn>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="2">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
                        item-value="id" label="* Academic Year" outlined persistent-hint
                        hint="* Please Select Academic Year" @change="toggleButtonVisibility" />
                </v-col>

                <!-- <v-col cols="12" sm="2" v-if="this.division_offering_list.length > 0">
          <p><v-icon color="error">*</v-icon><b>Division</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div_off"
            :items="division_offering_list"
            item-text="division"
            item-value="id"
            multiple
            label="Division"
            outlined
            persistent-hint
            hint="Please Select Division"
          />
        </v-col> -->
                <v-col cols="12" sm="2">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="event_type" :items="event_type_list"
                        item-text="name" item-value="id" label="* Event Type" outlined persistent-hint
                        hint="* Please Select Event Type" />
                </v-col>
                <v-col cols="12" sm="2" class="pt-4" v-if="this.standard_list.length > 0">
                    <v-switch label="Is For Particular Standard"
                        v-model="is_applicable_for_particular_standard_ap"></v-switch>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="is_applicable_for_particular_standard_ap" class="pt-4 mt-4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                        item-text="standard" item-value="id" label="* Standard" outlined persistent-hint
                        hint="* Please Select Standard" multiple />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field dense outlined rounded v-model="selected_date" v-bind="attrs" v-on="on"
                                label="*" prepend-icon="event" hint="* From Date Is Inclusive"
                                persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field dense outlined rounded v-model="to_date" v-on="on" v-bind="attrs"
                                prepend-icon="event" label="*" hint="* To Date Is Exclusive"
                                persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="todate" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <!-- <p><b>Title</b></p> -->
                    <!-- <v-icon color="error">*</v-icon> -->
                    <v-text-field rounded label="* Please Enter Title" placeholder="* Please Enter Title" outlined dense
                        type="text" v-model="title"></v-text-field>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <!-- <p><b>Description</b></p> -->
                    <v-textarea outlined name="input-7-4" v-model="description" placeholder="Please Enter Description"
                        label="Enter Description"></v-textarea>
                </v-col>
            </v-row>
            Note: Only one event can be added for a particular standard/grade on a particular date

            <v-row justify="center" dense v-if="this.event_type && this.title">
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col col="12" sm="2" md="2">
                    <v-btn color="warning" @click="addPlanningData()">Save</v-btn>
                </v-col>
            </v-row>
            <v-row dense v-if="showButton">
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2"></v-col>
                <v-col cols="12" md="3" style="margin-right: 10px;"><v-btn color="warning"
                        @click="handleButtonClick()">Fetch
                        Academic
                        Planner</v-btn></v-col>
                <v-col cols="12" md="1"></v-col>
            </v-row>


        </v-card>
        <v-row dense justify="center">
            <v-radio-group inline v-model="view" row>
                <v-radio color="brand" label="Single" value="Single"></v-radio>
                <v-radio color="brand" label="Cummalative" value="Cummalative"></v-radio>
            </v-radio-group>
        </v-row>
        <template v-if="view == 'Single'">
            <v-card class="box" v-if="planning_list.length > 0">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>Academic Planning Data</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <!-- <v-row justify="center">
        <v-col cols="12" md="2" sm="2"> </v-col>
        <v-col cols="12" md="4" sm="4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
       
      </v-row> -->
                <v-data-table :headers="headers" :items="bookList1" :search="search" @current-items="getFiltered">
                    <!-- <template v-slot:top>
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Academic Planning Data</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template> -->
                    <template v-slot:[`item.edit`]="{ item }">
                        <div>
                            <v-avatar size="25" class="edit-avatar">
                                <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <div>
                            <v-avatar size="35">
                                <v-icon class="mr-4 v-icon-size" color="red"
                                    @click="deletePlanData(item)">mdi-trash-can</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:[`item.isweeklyoff`]="{ item }">
                        <span v-if="item.isweeklyoff">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:top class="pb-5">
                        <v-row>
                            <v-col cols="12" sm="1" md="1"></v-col>
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                            <v-col cols="12" sm="1" md="1"></v-col>
                            <v-col cols="12" md="4" sm="4">
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                    hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
        </template>
        <template v-if="view == 'Cummalative'">
            <v-row dense>
                <!-- {{ cum_list }} -->
                <v-col cols="12" sm="12" md="12" v-for="(value, key) in cum_list" :key="key">
                    <v-card class="box box1" fill-height>
                        <v-btn class="link" small style="float: right;" @click="editCommnByMsgId(key, value)"
                            color="primary"> <v-icon class="edit-v-icon" title="edit">edit</v-icon></v-btn>
                        <v-btn class="link mr-2" small :loading="delete_loader" style="float: right;"
                            @click="deleteCommnByMsgId(key)" color="red"> <v-icon>mdi-trash-can</v-icon></v-btn>
                        <span v-for="(std, ind) in value" :key="ind">
                            <h3 v-if="ind == 0">Title : {{ value[0] }}</h3>
                            <div v-else-if="ind == 1">
                                <b> Description:</b>{{ value[1] }} <br />
                                <span> {{ std }} </span><br />
                            </div>
                            <v-btn color="info" small style="margin: 2px;" v-else>
                                {{ std }}
                            </v-btn>
                        </span>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <v-card class="box" v-if="semester_planning_list_details.length > 0">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>Semester Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table :headers="headers_1" :items="semester_planning_list_details" :search="search"> </v-data-table>
        </v-card>
        <v-dialog v-model="edit_dialog" max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Academic Planner </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <!-- {{this.editRecord}} -->
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="4" md="4">
                                <p><b>Title</b></p>
                                <v-text-field outlined dense type="text" v-model="editRecord.title"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <p><b>Event Date</b></p>
                                <!-- <v-menu ref="menu1" v-model="menu5" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense v-model="editRecord.date_edit" v-bind="attrs" v-on="on" prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="edit_date" no-title @input="menu5 = false"></v-date-picker>
          </v-menu> -->
                                <v-dialog ref="dialog" v-model="menu5" :return-value.sync="editRecord.date_edit"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="editRecord.date_edit" outlined dense
                                            prepend-icon="mdi-calendar" hint="YYYY-MM-DD FORMAT" readonly v-bind="attrs"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="editRecord.date_edit" scrollable>
                                        <v-spacer></v-spacer><v-btn text color="primary"
                                            @click="menu5 = false">Cancel</v-btn>
                                        <v-btn text color="primary"
                                            @click="$refs.dialog.save(editRecord.date_edit)">OK</v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3" md="3">
                                <p><b>Description</b></p>
                                <v-textarea outlined name="input-7-4" v-model="editRecord.description"
                                    label="Update Description"></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <p><b>Weekly Off</b></p>
                                <v-switch v-model="editRecord.edit_isweeklyoff"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <p><b>Standard</b></p>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="editRecord.standard"
                                    :items="standard_list" item-text="standard" item-value="standard" label="Standard"
                                    outlined persistent-hint hint="*Please Select Standard" />
                            </v-col>
                            <!-- <v-col cols="12" sm="2">
                                     <p><b>Division</b></p>
                                    <v-autocomplete color="#0F2027" dense rounded required v-model="editRecord.division" :items="division_list"
                                        item-text="division" item-value="division" label="Division" outlined persistent-hint
                                        hint="*Please Select Standard" />
                                </v-col> -->
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="updatePlanningData(item)" :loading="loader">Update</v-btn>
                            <v-btn class="button" @click="edit_dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog v-model="mark_holiday_dialog" max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Mark Weekly-Off</strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="2" md="2"> Is For Particular Standard<v-switch
                                    v-model="is_applicable_for_particular_standard"></v-switch> </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="2">
                                <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="mark_holiday_ay"
                                    :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined
                                    persistent-hint hint="Please Select Academic Year" />
                            </v-col>
                            <v-col cols="12" sm="2" v-if="is_applicable_for_particular_standard == true">
                                <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="particular_standard"
                                    :items="standard_list" item-text="standard" item-value="id" label="Standard"
                                    outlined persistent-hint hint="Please Select Standard" multiple />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense v-model="holiday_from" v-bind="attrs" v-on="on"
                                            prepend-icon="event" persistent-hint
                                            hint="* From Date Is Inclusive"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="holidayfrom" no-title
                                        @input="menu3 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                                <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense v-model="holiday_to" v-bind="attrs" v-on="on"
                                            prepend-icon="event" persistent-hint
                                            hint="* To Date Is Exclusive"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="holidayto" no-title @input="menu4 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <p><v-icon color="error">*</v-icon><b>Day List</b></p>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="day" :items="day_list"
                                    item-text="day" item-value="id" label="Day" multiple outlined persistent-hint
                                    hint="Please Select Day" />
                            </v-col>
                            <v-col cols="12" sm="2">
                                <p><v-icon color="error">*</v-icon><b>Mark Weekly Off</b></p>
                                <v-checkbox v-model="is_weekly_off" label="Mark Weekly Off?"></v-checkbox>
                                <!-- <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="mark_event_type"
                  :items="event_type_list"
                  item-text="name"
                  item-value="id"
                  label="Event Type"
                  outlined
                  persistent-hint
                  hint="Please Select Event Type"
                /> -->
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3">
                                <p><v-icon color="error">*</v-icon><b>Title</b></p>
                                <v-text-field outlined dense type="text" v-model="mark_title"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <p><b>Description</b></p>
                                <v-textarea outlined name="input-7-4" v-model="mark_description"
                                    label="Enter Description"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="markHolidays()" :loading="loader">save</v-btn>
                            <v-btn class="button" @click="mark_holiday_dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_cum" max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>Edit Cummulative Academic Planner</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12" v-if="value_edit">
                    <v-card class="box">
                        <!-- {{ key_edit }}
                        {{ value_edit[0] }}
                        {{ value_edit[1] }} -->
                        <v-row dense justify="center">
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Edit Title" v-model="value_edit[0]" dense rounded
                                    outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense justify="center">
                            <v-col cols="12" sm="6" md="6">
                                <v-textarea outlined name="input-7-4" v-model="value_edit[1]"
                                    placeholder="Edit Description" label="Edit Description"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <center>
                    <v-btn class="button" @click="dialog_cum = false">Close</v-btn>
                    <v-btn class="button" :loading="edit_loader"
                        @click="editCum_Academic_Planner(key_edit, value_edit[0], value_edit[1])">Save</v-btn>
                </center>
            </v-card>
        </v-dialog>

        <!-- shiv code calendar -->
        <v-card class="box">
            <calendar-demo :ay="ay" :current_ay_name="current_ay_name" v-if="renderComponent"></calendar-demo>
        </v-card>
        <!-- shiv code calendar end -->
    </div>
</template>

<script>
import axios from "axios";
import calendar_demo from "./CalendarDemo.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import moment from "moment";
export default {
    components: {
        "calendar-demo": calendar_demo,
        Breadcrumbs
    },
    data: () => ({
        is_applicable_for_particular_standard: false,
        is_weekly_off: true,
        renderComponent: true,
        showButton: false,
        search: "",
        // extraBreadcrumbItems: [

        // ],
        // breadcrumbClass: "breadcrumb-style1",
        mark_holiday_dialog: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        ///////////////////////////////////////////////
        event_type_list: null,
        sel_event: null,
        ay_list: [],
        ay: "",
        current_ay_name: "",
        section_list: [],
        section: "",
        standard_list: [],
        standard: "",
        particular_standard: "",
        division_offering_list: [],
        div_off: "",
        event_type_list: [],
        day_list: [],
        day: "",
        mark_event_type: "",
        mark_holiday_ay: "",
        event_type: "",
        title: "",
        description: "",
        selected_date: "",
        holiday_from: "",
        holiday_to: "",
        to_date: "",
        date: new Date().toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        todate: new Date().toISOString().substr(0, 10),
        nowDate: new Date().toISOString().slice(0, 10),
        holidayfrom: new Date().toISOString().slice(0, 10),
        holidayto: new Date().toISOString().slice(0, 10),
        planning_list: [],
        mark_title: "",
        mark_description: "",
        view: "",
        cum_list: null,
        delete_loader: false,
        edit_loader: false,
        is_applicable_for_particular_standard_ap: false,
        // for calender

        // calender end
        headers: [
            { text: "Sr. No.", value: "count" },
            { text: "Title", value: "title" },
            { text: "Description", value: "description" },
            { text: "Date", value: "event_date" },
            { text: "Event Type", value: "eventtype" },
            { text: "Standard", value: "standard" },
            { text: "Is Weekly-Off", value: "isweeklyoff" },
            // { text: "Division", value: "divissionoffering" },
            { text: "Edit", value: "edit" },
            { text: "Delete", value: "delete" },
        ],
        headers_1: [
            { text: "Semester", value: "Semester" },
            { text: "Total Working Days", value: "Total_working_days" },
            { text: "Total Holidays", value: "Total_holidays" },
            { text: "Total Weekly Off", value: "Total_weekly_off" },
        ],
        editRecord: { title: "", description: "", id: "", date_edit: "", edit_isweeklyoff: "" ,standard:"",division:""},
        edit_dialog: false,
        loader: false,
        filterArr: [],
        semester_planning_list_details: [],
        filters: {
            eventtype: [],
            standard: [],
            event_date: [],
            isweeklyoff: [],
            // subjectcode: [],
            // subject: [],
        },
        key_edit: null,
        value_edit: null,
        dialog_cum: false,division_list:[],
    }),
    computed: {
        bookList1() {
            return this.planning_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    mounted() {
        this.onload();
        this.selected_date = this.formatDate(this.date);
        this.to_date = this.formatDate(this.todate);
        this.holiday_from = this.formatDate(this.holidayfrom);
        this.holiday_to = this.formatDate(this.holidayto);
        // for calender
    },
    watch: {
        date(val) {
            this.selected_date = this.formatDate(this.date);
        },
        todate(val) {
            this.to_date = this.formatDate(this.todate);
        },
        holidayfrom(val) {
            this.holiday_from = this.formatDate(this.holidayfrom);
        },
        holidayto(val) {
            this.holiday_to = this.formatDate(this.holidayto);
        },
        // std_id() {
        //   <calendar-demo></calendar-demo>;
        // },
    },
    methods: {
        handleButtonClick() {
            const data = {
                ay: this.ay,
            };

            this.renderComponent = false;
            axios
                .post("AcademicPlanner/getadminAcademicPlanner", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.mark_holiday_ay = res.data.curreny_ay;
                        this.planning_list = res.data.planning_list;
                        this.cum_list = res.data.cum_list;
                        this.day_list = res.data.day_list;
                        this.semester_planning_list_details = res.data.semester_planning_list_details;
                        this.current_ay_name = res.data.current_ay_name;
                        this.renderComponent = true;

                        // for calender
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.renderComponent = false;
                    }
                })

        },
        toggleButtonVisibility() {

            this.showButton = true;
        },

        async editCum_Academic_Planner(key_edit, title, description) {
            const formdata = {
                key: key_edit,
                title: title,
                description: description,
            };
            try {
                const res = await axios.post("/AcademicPlanner/editCommnByMsgId", formdata);
                //console.log(res.data.flag);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", res.data.snackbar);
                    this.onload();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.edit_loader = false;
                this.dialog_cum = false
            } catch (err) {
                console.log("err", err);
                this.showSnackbar("red", "Something went wrong!!!");
                this.edit_loader = false;
                this.dialog_cum = false
            } finally {
                console.log("bye...");
                this.edit_loader = false;
            }
        },
        editCommnByMsgId(key, value) {
            this.key_edit = key;
            this.value_edit = value;
            this.dialog_cum = true;
        },
        async deleteCommnByMsgId(key) {
            this.delete_loader = true;
            const formdata = {
                key: key,
            };
            try {
                const res = await axios.post("/AcademicPlanner/deleteCommnByMsgId", formdata);
                console.log(res.data.flag);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", res.data.snackbar);
                    this.onload();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.delete_loader = false;
            } catch (err) {
                console.log("err", err);
                this.showSnackbar("red", "Something went wrong!!!");
                this.delete_loader = false;
            } finally {
                console.log("bye...");
                this.delete_loader = false;
            }
        },
        resetData() {
            (this.event_type = ""),
                (this.title = ""),
                (this.description = ""),
                (this.day = ""),
                (this.mark_title = ""),
                (this.mark_description = ""),
                (this.standard = ""),
                (this.is_applicable_for_particular_standard = false),
                (this.is_weekly_off = true);
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            console.log("in col fin", val);
            return this.planning_list.map((d) => d[val]);
        },
        markHolidays() {
            if (!confirm("Are You Sure You Want To Mark Holidays...?")) return;
            if (this.is_applicable_for_particular_standard == false) {
                this.particular_standard = [];
            }
            const formData = {
                holiday_from: this.holiday_from,
                holiday_to: this.holiday_to,
                day: this.day,
                event_type: this.mark_event_type,
                standard: this.particular_standard,
                ay: this.mark_holiday_ay,
                title: this.mark_title,
                description: this.mark_description,
                is_weekly_off: this.is_weekly_off,
            };
            this.overlay = true;
            this.renderComponent = false;
            axios
                .post("/AcademicPlanner/markHolidays", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Marked Successfully..");
                        this.mark_holiday_dialog = false;
                        this.renderComponent = true;
                        this.planning_list = res.data.planning_list;
                        this.resetData();
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },

        deletePlanData(item) {
            if (!confirm("Are You Sure You Want To Delete...?")) return;
            const formData = {
                id: item.id,
            };
            this.overlay = true;
            axios
                .post("/AcademicPlanner/deletePlanData", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Deleted Successfully..");
                        this.planning_list = res.data.planning_list;
                        this.cum_list = res.data.cum_list;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },

        editItem(item) {
            this.editRecord.title = item.title;
            this.editRecord.description = item.description;
            this.editRecord.id = item.id;
            this.editRecord.date_edit = item.date_edit;
            this.editRecord.edit_isweeklyoff = item.isweeklyoff;
            this.editRecord.standard = item.standard;
            this.editRecord.division = item.divissionoffering;
            //this.editRecord.edit_date = item.date_edit.toISOString().slice(0, 10),
            this.edit_dialog = true;
        },
        updatePlanningData() {
            this.renderComponent = false;
            this.overlay = true;
            axios
                .post("/AcademicPlanner/updatePlanningData", this.editRecord)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Updated Successfully..");
                        this.planning_list = res.data.planning_list;
                        this.cum_list = res.data.cum_list;
                        this.edit_dialog = false;
                        this.renderComponent = true;
                    }
                    else if (res.data.flag == "No") {
                        this.showSnackbar("green", res.data.snackbar);
                        this.planning_list = res.data.planning_list;
                        this.cum_list = res.data.cum_list;
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.edit_dialog = false;
                        this.renderComponent = true;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.edit_dialog = false;
                    }
                    this.overlay = false;
                    this.edit_dialog = false;
                })
                .catch((error) => {
                    // this.onerror(error);
                    this.overlay = false;
                    this.edit_dialog = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.edit_dialog = false;
                    this.renderComponent = true;
                    // this.selected_date=""
                });
        },
        addPlanningData() {
            if (this.is_applicable_for_particular_standard_ap == true) {
                if (this.standard == "" || this.standard == [] || this.standard == null) {
                    this.showSnackbar("red", "Please Select At Least 1 Standard");
                    return;
                }
            }
            const data = {
                fromdate: this.selected_date,
                todate: this.to_date,
                ay: this.ay,
                standard: this.standard,
                //div_off: this.div_off,
                title: this.title,
                description: this.description,
                event_type: this.event_type,
            };
            this.overlay = true;
            this.renderComponent = false;
            axios
                .post("/AcademicPlanner/saveAcademicPlan", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Saved Successfully..");
                        this.planning_list = res.data.planning_list;
                        this.cum_list = res.data.cum_list;
                        this.renderComponent = true;
                        this.resetData();
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        // getDivOffByStandard() {
        //   const data = {
        //     ay: this.ay,
        //     standard: this.standard,
        //   };
        //   axios
        //     .post("/AccountingAndFees/getDivOffByStandard", data)
        //     .then((res) => {
        //       if (res.data.flag == "YES") {
        //         this.division_offering_list = res.data.division_offering_list;
        //       } else {
        //         this.showSnackbar("red", res.data.snackbar);
        //         sessionStorage.setItem("error-trace", res.data.error_trace);
        //       }
        //     })
        //     .catch((error) => {
        //       this.onerror(error);
        //     })
        //     .finally(() => {});
        // },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        //////////////////////////////////////
        onload() {
            this.renderComponent = false;
            axios
                .post("AcademicPlanner/adminAcademicPlanner")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                        this.mark_holiday_ay = res.data.curreny_ay;
                        (this.standard_list = res.data.standard_list), (this.event_type_list = res.data.event_type_list);
                        this.planning_list = res.data.planning_list;
                        this.cum_list = res.data.cum_list;
                        this.day_list = res.data.day_list;
                        this.semester_planning_list_details = res.data.semester_planning_list_details;
                        this.division_list = res.data.division_list;
                        this.current_ay_name = res.data.current_ay_name;
                        this.overlay = false;
                        // for calender
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.renderComponent = true;
                });
        },
    },
};
</script>

<style></style>
